import { PHOTOS } from "@/assets/photos";
import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";

import { PageHero, Section } from "@/components/site/section";
import { squadQuery } from "@/lib/site-queries";

export const Route = createFileRoute("/national-team/women")({
  head: () => ({
    meta: [
      { title: "Argentina Women's National Team | Argentinian.Soccer" },
      { name: "description", content: "Argentina Women's National Team — squad, news and coverage." },
      { property: "og:title", content: "Argentina Women's National Team | Argentinian.Soccer" },
      { property: "og:url", content: "/national-team/women" },
    ],
    links: [{ rel: "canonical", href: "/national-team/women" }],
  }),
  loader: ({ context }) => context.queryClient.ensureQueryData(squadQuery("women")),
  component: WomenPage,
});

function WomenPage() {
  const { data } = useSuspenseQuery(squadQuery("women"));
  return (
    <>
      <PageHero eyebrow="National Team" title="Argentina Women's National Team" image={PHOTOS.messiHighfive} />
      <Section eyebrow="Women" title="Squad">
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {data.map((p) => (
            <div key={p.id} className="flex items-center justify-between rounded-lg border border-border bg-card p-4">
              <div>
                <p className="font-display font-bold text-navy">{p.name}</p>
                <p className="text-xs text-muted-foreground">{p.position} · {p.club}</p>
              </div>
              <span className="font-display text-2xl font-bold text-primary">{p.shirt_number}</span>
            </div>
          ))}
        </div>
      </Section>
    </>
  );
}
